import { useQuery } from '@tanstack/react-query';

import { acesso } from '@/shared/api/resources';

/**
 * Situacao da manutencao da plataforma.
 *
 * A pergunta e publica e barata, e a resposta muda quando a administracao da
 * plataforma abre ou encerra uma janela. Repetir a cada minuto e o que faz a tela de
 * quem esta trabalhando ir para a manutencao sem precisar recarregar.
 */
export function useMaintenanceStatus() {
  return useQuery({
    queryKey: ['acesso', 'manutencao'],
    queryFn: ({ signal }) => acesso.maintenanceStatus(signal),
    refetchInterval: 60_000,
    staleTime: 30_000,
    retry: false,
  });
}

/** Data e hora no fuso de Brasilia, como as telas mostram. */
export function quando(iso: string): string {
  return new Date(iso).toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
